import{excludeKeys}from"filter-obj";
import setErrorMessage from"set-error-message";
import setErrorProps from"set-error-props";
import setErrorStack from"set-error-stack";

import{getPluginsMethodNames}from"../instance/main.js";













export const assignError=(
error,
{message,stack,...newProps},
plugins)=>
{
if(stack!==undefined){
setErrorStack(error,stack)
}

if(message!==undefined){
setErrorMessage(error,message)
}

if(Reflect.ownKeys(newProps).length===0){
return
}

const keys=excludeKeys(newProps,[
...OMITTED_PROPS,
...getPluginsMethodNames(plugins)]
);
setErrorProps(error,keys)
};

const OMITTED_PROPS=["wrap","constructorArgs"];